export default __webpack_public_path__ + "static/media/navigation_transition-right.ba482853.ogg";